<template>
  <div class="Chat__wrapper">
    <!--v-infinite-scroll="getMessages"
         infinite-scroll-disabled="busy"
         infinite-scroll-immediate-check="false"-->
    <div class="Chat__main-container">
    <transition name="appear-from-top">
      <div v-if="!messages.length"
           class="Chat__empty-result-box">
        <div class="Chat__empty-result-img"></div>
        <div class="Chat__empty-result-text">
          No messages yet.
          </br>
          Start chatting!
        </div>
      </div>
    </transition>

    <transition name="appear-from-bottom">
      <div class="Chat__container"
           v-if="messages.length">
        <div v-for="(msg, index) in messages"
             :key="index"
             class="Chat__message">
          <div class="Chat__message-info">
            <img class="Chat__message-author-avatar"
                 :src="getUserInfo(msg.creatorId).avatarUrl || '../../../../static/images/default-user-avatar.jpg'"/>
            <div class="Chat__message-author-name">
              {{ getUserInfo(msg.creatorId).name }}
            </div>
            <div class="Chat__message-sent-at">
              {{ msg.createdAtMillis | moment("h:mm a") }}
            </div>
          </div>

          <div v-if="msg.bodyType.text"
               class="Chat__message-text-container">
            {{ msg.bodyType.text.body }}
          </div>

          <div v-else-if="msg.bodyType.ping"
               class="Chat__message-ping-container">
            <i class="icon-ic_hand-up"></i>
          </div>

          <div v-else-if="msg.bodyType.image"
               class="Chat__message-image-container">
            <img class="Chat__message-image"
                 :src="msg.bodyType.image.imageUrl"
                 v-fallback-src="'../../../../static/images/default-user-avatar.jpg'"/>
          </div>
        </div>

        <infinite-loading
        class="Chat__infinite-loading-container"
        spinner="circles"
        direction="top"
        :on-infinite="getMessages"
        ref="infiniteLoading">
          <span slot="no-more"></span>
        </infinite-loading>
      </div>
    </transition>
    </div>

    <div class="Chat__footer">
      <transition name="appear-from-bottom" mode="out-in">
        <progress-circle
        class="Chat__attach-progress"
        v-if="percentComplete"
        :progress="percentComplete">
        </progress-circle>

        <!--
        https://cl.ly/1C1B2S0h2X0t
        <label
        v-else
        for="file-upload"
        class="Chat__attach-label">
          <i class="icon-ic_attach Chat__attach"></i>
        </label>
        -->
      </transition>
      <input
      class="Chat__attach-input"
      id="file-upload"
      type="file"
      accept="image/*"
      name="fileUpload"
      @change="onFileChange">

      <input
      v-focus
      type="text"
      name="message"
      class="Chat__message-field"
      placeholder="Type your message here..."
      v-model="message"
      @keyup.enter="submit"/>
      <i class="icon-ic_hand-up Chat__hand-up"
         @click="handUp"></i>
    </div>
  </div>
</template>

<script>
  import ProgressCircle from '@/components/common/progress-circle/progress-circle';

  export default {
    name: 'Chat',
    components: {
      ProgressCircle
    },
    data() {
      return {
        message: null,
        busy: null,
        file: null,
        percentComplete: null
      };
    },
    computed: {
      messages() {
        return this.$store.getters.messages;
      }
    },
    methods: {
      getUserInfo(id) {
        return this.$store.getters.usersInfo[id] || {};
      },

      submit() {
        if (this.message) {
          this.$store.dispatch(
            'sendChatMessage',
            {type: 'text', data: this.message}
          );
          this.message = null;
        }
      },

      getMessages($state) {
        this.$store.dispatch('getChatMessages').then(endOfList => {
          if ($state) {
            if (endOfList) {
              $state.complete();
            } else {
              $state.loaded();
            }
          }
        });
      },

      handUp() {
        this.$store.dispatch(
          'sendChatMessage',
          {type: 'ping'}
        );
      },

      uploadProgress(e) {
        if (e.lengthComputable) {
          this.percentComplete = Math.round((e.loaded * 100) / e.total);
        } else {
          this.percentComplete = null;
        }
      },

      onFileChange(e) {
        const files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          return;
        }
        this.file = files[0];
        this.$store.dispatch(
          'sendChatImage',
          {
            file: this.file,
            onprogress: this.uploadProgress
          }
        ).then(() => {
          setTimeout(() => {
            this.percentComplete = null;
            this.file = null;
            e.target.value = null;
          }, 500);
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// chat.vue?22ff1226